<template>
  <div class="page-col">
    <div class="page-main">
      <!-- Header Premium -->
      <div class="list-header-premium d-flex flex-column flex-md-row align-items-center justify-content-between gap-3 p-0 mb-3" :class="{'bg-dark border-secondary': isDark}">
        <div class="d-flex align-items-center p-3">
          <div class="header-icon-wrapper mr-3 ml-2" style="background: linear-gradient(135deg, #0f172a 0%, #334155 100%);">
            <i class="fa fa-pie-chart text-white"></i>
          </div>
          <div class="header-text-container">
            <h4 class="mb-0 font-weight-bold" :class="isDark ? 'text-white' : 'text-dark'">Centro de Custo</h4>
            <p class="text-muted mb-0 small">Gestão e acompanhamento de centros de custo</p>
          </div>
        </div>

        <div class="d-flex align-items-center flex-wrap gap-2 p-3">
            <!-- Search Pill -->
            <div class="d-flex align-items-center bg-light rounded-pill p-1 shadow-xs border mr-2">
                <b-button-group class="mr-2">
                    <b-button variant="link" class="btn-icon-only text-muted" @click="filtroAvancado = !filtroAvancado" v-b-tooltip.hover title="Filtros Avançados">
                        <i class="fa fa-filter" :class="{'text-primary': filtroAvancado}"></i>
                    </b-button>
                    <b-button variant="link" class="btn-icon-only text-muted" @click="exportarExcel()" v-b-tooltip.hover title="Exportar Excel">
                        <i class="fa fa-file-excel-o"></i>
                    </b-button>
                    <b-button variant="link" class="btn-icon-only text-muted" @click="exportarHtml()" v-b-tooltip.hover title="Imprimir Listagem">
                        <i class="fa fa-print"></i>
                    </b-button>
                    <b-button variant="link" class="btn-icon-only text-danger" @click="limparFiltro()" v-b-tooltip.hover title="Limpar Filtros">
                        <i class="fa fa-ban"></i>
                    </b-button>
                </b-button-group>

                <div class="d-flex align-items-center px-2 border-left mr-2">
                    <b-form-input type="text" ref="edDescricao" v-model="filtrosRapidos.DESCRICAO" placeholder="Buscar por descrição..." class="border-0 bg-transparent" style="width: 250px" @keydown.enter.native="pesquisar()" />
                </div>
                <b-button variant="primary" pill class="px-4 font-weight-bold shadow-sm text-white" :disabled="isBusy" @click="pesquisar()">
                    <i class="fa fa-search mr-1"></i> FILTRAR
                </b-button>
            </div>

            <!-- Action Buttons -->
            <b-button variant="success" pill class="px-4 font-weight-bold shadow-sm" @click.stop.prevent="novo()">
              <i class="fa fa-plus-circle mr-2"></i>
              <span>Novo Centro</span>
            </b-button>
        </div>
      </div>

      <!-- Advanced Filter Panel -->
      <b-collapse v-model="filtroAvancado">
          <div class="px-4 pb-4">
              <div class="card card-filter-premium p-4 border-0 shadow-sm">
                  <b-row align-v="end">
                    <b-col md="2">
                      <label class="font-weight-bold text-muted small">ID</label>
                      <b-form-input type="text" v-model="filtrosRapidos.SEQUENCIA" placeholder="ID" class="custom-input-premium" @keydown.enter.native="pesquisar()"></b-form-input>
                    </b-col>
                    <b-col md="3">
                      <label class="font-weight-bold text-muted small">Status</label>
                      <b-form-select v-model="filtrosRapidos.STATUS" :options="[{value: '', text: 'Todos'}, {value: 'A', text: 'Ativo'}, {value: 'I', text: 'Inativo'}]" class="custom-input-premium" @change="pesquisar()"></b-form-select>
                    </b-col>
                  </b-row>
              </div>
          </div>
      </b-collapse>

      <!--/.row-->
      <b-row class="ml-0 mr-0 p-0" :class="isDark ? 'bg-dark' : 'bg-white'">
        <b-col sm="12" class="px-2">
          <div class="bg-white rounded border shadow-sm overflow-hidden">
            <b-table 
                    class="mb-0 table-finance"
                    id="table-centrocusto"
                    ref="tbl"
                    show-empty
                    empty-text="Informe o filtro para ver os registros "
                    responsive 
                    :sticky-header="stickyHeight"
                    hover 
                    small
                    :busy.sync="isBusy" 
                    :items="itensFiltrados" 
                    :fields="colunas"
                    :current-page="currentPage"
                    :per-page="perPage"
                    :dark="isDark"
                    @row-dblclicked="edit"
                    @row-clicked="clicarLinha"
                    :tbody-tr-class="rowClassSelecionado"    
                    >

              <!-- Cabeçalho: Seq -->
              <template #head(SEQUENCIA)>
                <SetFilter
                  label="ID"
                  v-model="filtros.SEQUENCIA"
                  :options="opcoes.SEQUENCIA"
                  :normalizeFn="normalize"
                  :dropdown-variant="isDark ? 'dark' : 'none'"
                />
              </template>

              <!-- Cabeçalho: Descrição -->
              <template #head(DESCRICAO)>
                <SetFilter
                  label="Descrição"
                  v-model="filtros.DESCRICAO"
                  :options="opcoes.DESCRICAO"
                  :normalizeFn="normalize"
                  :dropdown-variant="isDark ? 'dark' : 'none'"
                />
              </template>

              <!-- Cabeçalho: Status -->
              <template #head(STATUS)>
                <SetFilter
                  label="Status"
                  v-model="filtros.STATUS"
                  :options="opcoes.STATUS"
                  :normalizeFn="normalize"
                  :dropdown-variant="isDark ? 'dark' : 'none'"
                />
              </template>

              <template #cell(STATUS)="item">
                <b-badge pill class="badge-premium shadow-xs" :variant="colorirSTATUS(item.item.STATUS)">
                    {{traduzirSTATUS(item.item.STATUS)}}
                </b-badge>
              </template>

              <template #cell(actions)="item">
                <div class="d-flex justify-content-center gap-1">
                  <b-button type="button" @click.stop.prevent="edit(item.item)" variant="soft-primary" pill class="btn-icon-only shadow-sm" title="Editar" v-b-tooltip.hover>
                    <i class="fa fa-pencil"></i>
                  </b-button>
                  <b-button type="button" @click.stop.prevent="deleteItem(item.item)" variant="soft-danger" pill class="btn-icon-only shadow-sm" title="Excluir" v-b-tooltip.hover>
                    <i class="fa fa-trash"></i>
                  </b-button>
                </div>
              </template>

              <template #custom-foot="{ fields, items }">
                <b-tr>
                  <b-td colspan="4" class="text-left bg-light py-2 px-3">
                    <span class="text-muted small font-weight-bold">Total de registros: {{ itensFiltrados.length }}</span>
                  </b-td>
                </b-tr>
              </template>

            </b-table>
          </div>
        </b-col>
      </b-row>
    </div>  
  </div>
</template>

<script>
import SetFilter from '@/components/Cec/SetFilter.vue'
import { createCecTableToolsMixin } from '@/mixins/cecTableTools'
import { printHtmlReport, exportExcelXlsx , exportCsv } from '@/utils/RelatorioHTML';

export default {
  components: { SetFilter },
  mixins: [createCecTableToolsMixin({ rowsProp: 'lista', tblRef: 'tbl',preferVh: 65, useExternalPaging: true, filters: [
    { key: 'SEQUENCIA', type: 'number', label: 'ID' },
    { key: 'DESCRICAO', type: 'string', label: 'Descrição' },
    { key: 'STATUS', type: 'string', label: 'Status', labelMap: { 'A': 'Ativo', 'I': 'Inativo' } }
  ] })],
  data () {
    return {
      isLoading: false,
      status: '',
      isBusy: false,
      filtroAvancado: false,
      filtrosRapidos: {
        SEQUENCIA: '',
        DESCRICAO: '',
        STATUS: ''
      },
      colunas: [
        { key: 'SEQUENCIA', label: 'Seq', sortable: true, class:'align-middle text-right', thStyle: { width: '10%' } },
        { key: 'DESCRICAO', label: 'Descrição', sortable: true, class:'align-middle', thStyle: { width: '70%' } },
        { key: 'STATUS', label: 'Status', sortable: true, class:'align-middle text-center', thStyle: { width: '10%' } },
        { key: 'actions', label: 'Ações', class:'align-middle text-center p-0', thStyle: { width: '10%' }, sortable: false }
      ]
    }
  },
  computed: {
    isDark() {return this.$store.getters['tema/IS_DARK']  },
    currentPage: {
      get () { return this.$store.getters['centrocusto/PAGINA_ATUAL'] },
      set (value) { this.$store.commit('centrocusto/SET_PAGINA_ATUAL', value); }
    },
    perPage: {
      get () { return this.$store.getters['centrocusto/PER_PAGE'] || 25 },
      set (v) { this.$store.commit('centrocusto/SET_PER_PAGE', Number(v) || 25) }
    },
    lista: {
      get () { return this.$store.getters['centrocusto/LISTA'] },
      set (value) { this.$store.commit('centrocusto/SET_LISTA', value); }
    }
    ,
    DESCRICAO: {
      get () { return this.$store.getters['centrocusto/DESCRICAO'] },
      set (value) { this.$store.commit('centrocusto/SET_DESCRICAO', value); }
    }
  },
  methods: {
    clicarLinha(item) { this.$store.commit('centrocusto/SET_REGISTRO_SELECIONADO_ID', item.SEQUENCIA) },
    rowClassSelecionado(item, type) { if (type !== 'row' || !item) return ''; const selId = this.$store.getters['centrocusto/REGISTRO_SELECIONADO_ID']; return item.SEQUENCIA === selId ? 'cec-row-selected' : '' },
    
    scrollToSelected() {
      this.$nextTick(() => {
        const el = document.querySelector('.cec-row-selected')
        if (el) el.scrollIntoView({ behavior: 'smooth', block: 'center' })
      })
    },

    colorirSTATUS(item) { return item === 'A' ? 'success' : 'danger' },
    traduzirSTATUS(item) { return item === 'A' ? 'ATIVO' : 'INATIVO' },
    
    limparFiltro() { 
      this.filtrosRapidos.SEQUENCIA = ''
      this.filtrosRapidos.DESCRICAO = ''
      this.filtrosRapidos.STATUS = ''
      this.onClear()
      this.$store.commit('centrocusto/SET_LIMPAR', null)
    },

    novo () { this.$router.push(`/cadastros/centrocusto/add`) },
    edit (item) { this.$store.commit('centrocusto/SET_REGISTRO_SELECIONADO_ID', item.SEQUENCIA); this.$router.push(`/cadastros/centrocusto/edit/${item.SEQUENCIA}`) },
    
    async pesquisar () { 
      this.$store.commit('controle/setAguardando', true)
      try { 
        // Sincroniza filtros rápidos com a store se necessário, ou passa como params
        this.$store.commit('centrocusto/SET_DESCRICAO', this.filtrosRapidos.DESCRICAO)
        await this.$store.dispatch('centrocusto/GET_LISTA') 
        this.scrollToSelected()
      } catch(err) { 
        this.lista = []
      } finally { 
        this.$store.commit('controle/setAguardando', false) 
      } 
    },
    async deleteItem(item) {
      this.$store.commit('centrocusto/SET_REGISTRO_SELECIONADO_ID', item.SEQUENCIA)
      const resposta = await this.$bvModal.msgBoxConfirm(`Excluir o Cadastro: ${item.CODIGO} : ${item.DESCRICAO} ?`, {
        title: 'Excluir?', size: 'sm', buttonSize: 'lg', okVariant: 'primary', okTitle: 'SIM', cancelTitle: 'NAO', footerClass: 'p-2', hideHeaderClose: false, centered: true
      })
      if (resposta == false) return
      let excluirPayload = { registro: item, login: window.localStorage.getItem('login') }
      try {
        this.$store.commit('controle/setAguardando', true)
        await this.$http.post('/api/protected/centrocusto/delete', excluirPayload)
        await this.$store.dispatch('centrocusto/GET_LISTA')
        Tools.exibirMensagem(this.$store, 'Aviso', 'success', 'Registro excluído com sucesso')
      } catch (err) { Tools.exibirMensagem(this.$store, 'Aviso', 'warning', 'Não foi possível excluir') } finally { this.$store.commit('controle/setAguardando', false) }
    },
    exportarHtml () {
      printHtmlReport({
        rows: this.rowsHierarquizados,                 // seu array de dados
        columns: this.colunas,
        systemName: 'CECWeb',
        reportTitle: 'Listagem de Históricos do Caixa',
        printedBy: window.localStorage.getItem('login') ?? '—',
        observations: ``,
        pageSize: 'A4',
        landscape: true,                    // vira “deitado” se quiser
        footerTotals: [
          
        ],
      });
    },
    exportarExcel(){
      exportExcelXlsx ({
        rows: this.rowsHierarquizados,
        columns: this.colunas,
        filename: 'historicosCaixa.xls',
        sumKey: null
      });
    },
    exportarCsv(){
      exportCsv({
        rows: this.rowsHierarquizados,
        columns: this.colunas,
        filename: 'historicosCaixa.csv',
      });
    },
  },
  async created() { await this.pesquisar() }
}
</script>

<style scoped>
.list-header-premium {
  background: #fff;
  border-bottom: 1px solid #e2e8f0;
}

.header-icon-wrapper {
  width: 48px;
  height: 48px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 12px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
}

.header-icon-wrapper i {
  font-size: 1.5rem;
}

.card-filter-premium {
  background: #f8fafc;
  border: 1px solid #e2e8f0 !important;
  border-radius: 12px;
}

.custom-input-premium {
  border: 1px solid #e2e8f0;
  border-radius: 8px;
  padding: 0.5rem 0.75rem;
  transition: all 0.2s;
}

.custom-input-premium:focus {
  border-color: #3b82f6;
  box-shadow: 0 0 0 3px rgba(59, 130, 246, 0.1);
  outline: none;
}

.table-finance {
  font-size: 0.8rem !important;
}

.table-finance >>> thead th {
  background-color: #f8fafc !important;
  text-transform: uppercase;
  font-size: 0.7rem !important;
  letter-spacing: 0.05em;
  color: #64748b;
  border-top: none;
  border-bottom: 2px solid #e2e8f0 !important;
  padding: 0.4rem 0.75rem !important;
  position: sticky !important;
  top: 0;
  z-index: 20 !important;
  box-shadow: 0 2px 2px -1px rgba(0, 0, 0, 0.05);
}

.table-finance >>> tbody td {
  padding: 0.2rem 0.75rem !important;
  vertical-align: middle;
  border-bottom: 1px solid #f1f5f9;
}

.badge-premium {
  font-size: 0.7rem !important;
  padding: 0.25rem 0.6rem !important;
  font-weight: 600;
}

.btn-icon-only {
  width: 32px;
  height: 32px;
  padding: 0;
  display: inline-flex;
  align-items: center;
  justify-content: center;
}

.btn-soft-primary {
  background: #eff6ff;
  color: #3b82f6;
  border: none;
}

.btn-soft-primary:hover {
  background: #dbeafe;
  color: #2563eb;
}

.btn-soft-danger {
  background: #fef2f2;
  color: #ef4444;
  border: none;
}

.btn-soft-danger:hover {
  background: #fee2e2;
  color: #dc2626;
}

.shadow-xs {
  box-shadow: 0 1px 2px rgba(0, 0, 0, 0.05);
}

.gap-1 { gap: 0.25rem; }
.gap-2 { gap: 0.5rem; }
.gap-3 { gap: 1rem; }

/* Estilo para linha selecionada */
.table-finance >>> .cec-row-selected {
  background-color: rgba(59, 130, 246, 0.1) !important;
}

.table-finance >>> .cec-row-selected td {
  background-color: transparent !important;
  font-weight: 600;
  color: #1e40af;
}
</style>



// WEBPACK FOOTER //
// src/views/centrocusto/CentroCustoListagem.vue